import moment from '../utils/moment'

import { eventBus } from './global-bus'

import 'echarts/lib/chart/effectScatter'

const dataZoom = [
  {
    type: 'inside',
    start: 0,
    end: 100,
    zoomOnMouseWheel: false
  },
  {
    start: 0,
    end: 10,
    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
    handleSize: '80%',
    handleStyle: {
      color: '#f5f5f5',
      shadowBlur: 3,
      shadowColor: 'rgba(0, 0, 0, 0.6)',
      shadowOffsetX: 2,
      shadowOffsetY: 2
    }
  }
]

const grid = {
  left: '40',
  right: '30',
  top: '20',
  width: '90%'
}

const yAxis = {
  type: 'value',
  axisLine: {
    show: false
  },
  axisTick: {
    show: false
  },
  splitNumber: window.innerWidth > 768 ? 10 : 5
}

const scatterStyleFeedback = {
  color: 'rgb(120, 87, 179)',
  shadowColor: '#000',
  shadowBlur: 1,
  shadowOffsetX: 0,
  shadowOffsetY: 0
}

const scatterAlgoStyleAlert = {
  color: 'red',
  shadowColor: '#000',
  shadowBlur: 1,
  shadowOffsetX: 1,
  shadowOffsetY: 1
}

const scatterAiStyleAlert = {
  color: 'blue',
  shadowColor: '#000',
  shadowBlur: 1,
  shadowOffsetX: 1,
  shadowOffsetY: 1
}

const itemStyleNormal = {
  color: '#ffa003',
  shadowColor: '#000',
  shadowBlur: 1,
  shadowOffsetX: 1,
  shadowOffsetY: 1
}

let selectedTooltipChart
const tooltip = {
  triggerOn: 'click',
  position: 'top',
  formatter: params => {
    let value
    const alertDesc = params?.data[2]?.alert?.description ? `<span class="text-dark-grey">Reason</span> - ${params.data[2].alert.description}` : ''
    if (params?.data?.length) {
      eventBus.$emit('tooltipOpened', params)
      const data = params.data[2]
      selectedTooltipChart = data?.alert?.type
      value = Object.keys(data.vitalValues).reduce((prev, curr) => {
        const alertClass = data.vitalValues[curr]?.alerts && data.alert?.type === data.vitalValues[curr]?.alerts[0]?.type ? 'text-danger' : ''
        if (data.vitalValues[curr].value === -1) return prev
        return `
        ${prev}
        <br/>
        <span class="${alertClass}">
          <span class="text-dark-grey ph1 ${alertClass}">${curr}</span> - ${data.vitalValues[curr]?.value}
        </span>
        `
      }, `<span class="text-violet pv0 ph1 ma0">${data.xAxis}</span>`)
    }
    let description = ''
    if (alertDesc) {
      description = `
        <div class="display-flex maxw25 ph1">
          <div class="text-elipsis maxw25" id="${params.data[2].alert?.type}-alertDesc">
            <span>${alertDesc}</span>
            <span class="read-less text-violet pointer none" id="${params.data[2].alert?.type}-readLess"> Read Less</span>
          </div>
          <span class="read-more text-violet pointer" id="${params.data[2].alert?.type}-readMore"> Read More</span>
        </div>
        `
    }
    if (params?.componentSubType) {
      let submitFeedbackBtn = ''
      if (!params?.data[2]?.feedback) {
        submitFeedbackBtn = `<div class="submit-feedback bg-violet text-white pa1 br-bottom0-5 pointer" id="${params.data[2].alert?.type}-submitFeedback">Submit Feedback</div>`
      }

      return `
      <div class="bg-white pt1 box-shadow br0-8" id="${params.data[2]?.alert?.type}-tooltipWrapper">
        ${value}
        <br/>
        ${description}
        <br/>
        ${submitFeedbackBtn}
        <div class="arrow-down arrow-down-bg-white" id="${params.data[2].alert?.type}-downArrow"></div>
      </div>`
    }
    if (params?.componentSubType === 'line') {
      return `<div class="bg-white pa1 box-shadow br0-8">${value} <div class="arrow-down arrow-down-bg-white"></div></div>`
    }
  },
  trigger: 'item',
  axisPointer: {
    type: 'cross'
  },
  enterable: true,
  alwaysShowContent: true,
  backgroundColor: '#fff',
  extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);text-align:left;padding:0;z-index:9999;',
  textStyle: {
    color: '#000'
  }
}

document.querySelector('body').addEventListener('click', e => {
  if (e.target.classList.contains('read-more')) {
    document.getElementById(`${selectedTooltipChart}-readMore`).style.display = 'none'
    document.getElementById(`${selectedTooltipChart}-readLess`).style.display = 'block'
    document.getElementById(`${selectedTooltipChart}-downArrow`).style.display = 'none'
    document.getElementById(`${selectedTooltipChart}-alertDesc`).classList.add('expand-tooltip')
  }
  if (e.target.classList.contains('read-less')) {
    document.getElementById(`${selectedTooltipChart}-readMore`).style.display = 'block'
    document.getElementById(`${selectedTooltipChart}-readLess`).style.display = 'none'
    document.getElementById(`${selectedTooltipChart}-downArrow`).style.display = 'block'
    document.getElementById(`${selectedTooltipChart}-alertDesc`).classList.remove('expand-tooltip')
  }
  if (e.target.classList.contains('submit-feedback')) {
    document.getElementById(`${selectedTooltipChart}-tooltipWrapper`).style.display = 'none'
    const submitButton = document.getElementById(`${selectedTooltipChart}-submitFeedback`)
    submitButton.dispatchEvent(new Event('openSubmitFeedBack', { bubbles: true, cancelable: false }))
  }
})

const brush = {
  xAxisIndex: 'all',
  brushLink: 'all',
  outOfBrush: {
    colorAlpha: 1
  }
}

const toolbox = {
  show: true,
  top: -8,
  right: 20,
  feature: {
    dataZoom: {
      show: true,
      yAxisIndex: 'none',
      title: {
        zoom: 'Zoom Area',
        back: 'Back'
      }
    },
    brush: {
      type: ['lineX'],
      title: {
        lineX: 'Select Area'
      }
    }
  },
  tooltip: {
    show: true,
    backgroundColor: '#222',
    formatter: param => param.title,
    textStyle: {
      fontSize: 10
    },
    extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
  }
}

const getOptionsData = () => {
  return {
    temperatureData: [[]],
    butaneData: [[]],
    sulphurDioxideData: [[]],
    carbonDioxideData: [[]],
    temperatureAlgoMarkPoint: {
      data: []
    },
    temperatureAiMarkPoint: {
      data: []
    },
    butaneAlgoMarkPoint: {
      data: []
    },
    butaneAiMarkPoint: {
      data: []
    },
    sulphurDioxideAlgoMarkPoint: {
      data: []
    },
    sulphurDioxideAiMarkPoint: {
      data: []
    },
    carbonDioxideAlgoMarkPoint: {
      data: []
    },
    carbonDioxideAiMarkPoint: {
      data: []
    },
    temperatureFeedbackPoint: {
      data: []
    },
    butaneFeedbackPoint: {
      data: []
    },
    sulphurDioxideFeedbackPoint: {
      data: []
    },
    carbonDioxideFeedbackPoint: {
      data: []
    },
    xAxisData: []
  }
}

let optionsData = {}

// for markarea in graphs
const markArea = {
  data: [],
  itemStyle: {
    color: 'rgb(139 195 74)',
    opacity: '0.2'
  }
}

const prepareData = ({ vitals, minimize, alertId, submittedFeedbacks }) => {
  optionsData = JSON.parse(JSON.stringify(getOptionsData()))
  // dataZoom[1].show = !minimize
  // toolbox.show = !minimize
  let currentModel
  for (const vital of vitals) {
    const { temperature, butane, sulphurDioxide, carbonDioxide, datetime, id: vitalId, deviceId, model_info } = vital
    const xAxis = moment.formatDate(datetime * 1000, 'DD MMM, YYYY, HH:mm:ss')
    const vitalValues = {
      TEMP: temperature,
      BU: butane,
      SD: sulphurDioxide,
      CD: carbonDioxide
    }

    currentModel = currentModel || model_info?.modelInfo
    // xAxis Data
    optionsData.xAxisData.push(xAxis)

    // pulse
    if (temperature?.value >= 0) {
      const graphPoint = [
        xAxis,
        temperature?.value,
        {
          vitalValues,
          xAxis,
          vitalId,
          deviceId,
          type: 'TEMPERATURE',
          model: model_info?.modelInfo,
          modelInfo: model_info,
          markpointVal: {
            xAxis,
            yAxis: temperature?.value,
            vitalValues
          },
          feedback: null
        }
      ]
      optionsData.temperatureData[optionsData.temperatureData.length - 1].push(graphPoint)
      if (currentModel !== model_info?.modelInfo) {
        optionsData.temperatureData.push([graphPoint])
      }
    }

    // butane
    if (butane?.value >= 0) {
      const graphPoint = [
        xAxis,
        butane?.value,
        {
          vitalValues,
          xAxis,
          vitalId,
          deviceId,
          type: 'BUTANE',
          model: model_info?.modelInfo,
          modelInfo: model_info,
          markpointVal: {
            xAxis,
            yAxis: butane?.value,
            vitalValues
          }
        }
      ]
      optionsData.butaneData[optionsData.butaneData.length - 1].push(graphPoint)
      if (currentModel !== model_info?.modelInfo) {
        optionsData.butaneData.push([graphPoint])
      }
    }
    // carbon
    if (carbonDioxide?.value >= 0) {
      const graphPoint = [
        xAxis,
        carbonDioxide?.value,
        {
          vitalValues,
          xAxis,
          vitalId,
          deviceId,
          type: 'CARBONDIOXIDE',
          model: model_info?.modelInfo,
          modelInfo: model_info,
          markpointVal: {
            xAxis,
            yAxis: carbonDioxide?.value,
            vitalValues
          }
        }
      ]
      optionsData.carbonDioxideData[optionsData.carbonDioxideData.length - 1].push(graphPoint)
      if (currentModel !== model_info?.modelInfo) {
        optionsData.carbonDioxideData.push([graphPoint])
      }
    }
    // sulphur
    if (sulphurDioxide?.value) {
      const graphPoint = [
        xAxis,
        sulphurDioxide?.value,
        {
          vitalValues,
          xAxis,
          vitalId,
          deviceId,
          type: 'sulphurDioxide',
          model: model_info?.modelInfo,
          modelInfo: model_info,
          markpointVal: {
            xAxis,
            yAxis: sulphurDioxide?.value,
            vitalValues
          },
          feedback: null
        }
      ]
      optionsData.sulphurDioxideData[optionsData.sulphurDioxideData.length - 1].push(graphPoint)
      if (currentModel !== model_info?.modelInfo) {
        optionsData.sulphurDioxideData.push([graphPoint])
      }
    }

    // Pulse mark point
    if ((!alertId && temperature?.alerts?.length && temperature?.alerts?.some(a => !a?.isPseudoAlert)) || (alertId && temperature?.alerts?.some(a => (a.id === alertId || a._id === alertId)))) {
      if (temperature?.alerts[0].model_info.modelInfo === 'Default Settings') {
        optionsData.temperatureAlgoMarkPoint.data.push(
          {
            xAxis,
            yAxis: temperature?.value,
            alert: temperature?.alerts[0],
            vitalValues
          }
        )
      } else {
        optionsData.temperatureAiMarkPoint.data.push(
          {
            xAxis,
            yAxis: temperature?.value,
            alert: temperature?.alerts[0],
            vitalValues
          }
        )
      }

      submittedFeedbacks.some(ele => {
        if (ele.startTime === ele.endTime && ele.startTime === datetime) {
          optionsData.temperatureFeedbackPoint.data.push({
            xAxis,
            yAxis: temperature?.value,
            alert: temperature?.alerts[0],
            vitalValues
          })

          optionsData.temperatureMarkPoint.data.splice(optionsData.temperatureMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: temperature?.value,
            alert: temperature?.alerts[0],
            vitalValues,
            feedback: ele
          })
        }
      })
    } else {
      submittedFeedbacks.some(ele => {
        if (ele.startTime === datetime && temperature?.value >= 0) {
          optionsData.temperatureFeedbackPoint.data.push({
            xAxis,
            yAxis: temperature?.value,
            vitalValues,
            feedback: ele
          })
          if (optionsData.temperatureData[0].length) {
            const normalPointIndex = optionsData.temperatureData[0].findIndex(e => (new Date(e[0]).getTime() / 1000) === datetime)
            if (normalPointIndex > -1) {
              optionsData.temperatureData[0][normalPointIndex].feedback = ele
            }
          }
        }
      })
    }

    // butane mark point
    if ((!alertId && butane?.alerts?.length && butane?.alerts?.some(a => !a?.isPseudoAlert)) || (alertId && butane?.alerts?.some(a => (a.id === alertId || a._id === alertId)))) {
      if (butane?.alerts[0].model_info.modelInfo === 'Default Settings') {
        optionsData.butaneAlgoMarkPoint.data.push(
          {
            xAxis,
            yAxis: butane?.value,
            alert: butane?.alerts[0],
            vitalValues
          }
        )
      } else {
        optionsData.butaneAiMarkPoint.data.push(
          {
            xAxis,
            yAxis: butane?.value,
            alert: butane?.alerts[0],
            vitalValues
          }
        )
      }

      submittedFeedbacks.some(ele => {
        if (ele.startTime === ele.endTime && ele.startTime === datetime) {
          optionsData.butaneFeedbackPoint.data.push({
            xAxis,
            yAxis: butane?.value,
            alert: butane?.alerts[0],
            vitalValues
          })

          optionsData.butaneAlgoMarkPoint.data.splice(optionsData.butaneAlgoMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: butane?.value,
            alert: butane?.alerts[0],
            vitalValues,
            feedback: ele
          })

          optionsData.butaneAiMarkPoint.data.splice(optionsData.butaneAiMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: butane?.value,
            alert: butane?.alerts[0],
            vitalValues,
            feedback: ele
          })
        }
      })
    } else {
      submittedFeedbacks.some(ele => {
        if (ele.startTime === datetime && butane?.value >= 0) {
          optionsData.butaneFeedbackPoint.data.push({
            xAxis,
            yAxis: butane?.value,
            vitalValues,
            feedback: ele
          })

          if (optionsData.butaneData[0].length) {
            const normalPointIndex = optionsData.butaneData[0].findIndex(e => (new Date(e[0]).getTime() / 1000) === datetime)
            if (normalPointIndex > -1) {
              optionsData.butaneData[0][normalPointIndex].feedback = ele
            }
          }
        }
      })
    }

    // carbon mark point
    if ((!alertId && carbonDioxide?.alerts?.length && carbonDioxide?.alerts?.some(a => !a?.isPseudoAlert)) || (alertId && carbonDioxide?.alerts?.some(a => (a.id === alertId || a._id === alertId)))) {
      if (carbonDioxide?.alerts[0].model_info.modelInfo === 'Default Settings') {
        optionsData.carbonDioxideAlgoMarkPoint.data.push(
          {
            xAxis,
            yAxis: carbonDioxide?.value,
            alert: carbonDioxide?.alerts[0],
            vitalValues
          }
        )
      } else {
        optionsData.carbonDioxideAiMarkPoint.data.push(
          {
            xAxis,
            yAxis: carbonDioxide?.value,
            alert: carbonDioxide?.alerts[0],
            vitalValues
          }
        )
      }

      submittedFeedbacks.some(ele => {
        if (ele.startTime === ele.endTime && ele.startTime === datetime) {
          optionsData.carbonDioxideFeedbackPoint.data.push({
            xAxis,
            yAxis: carbonDioxide?.value,
            alert: carbonDioxide?.alerts[0],
            vitalValues
          })

          optionsData.carbonDioxideAlgoMarkPoint.data.splice(optionsData.carbonDioxideAlgoMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: carbonDioxide?.value,
            alert: carbonDioxide?.alerts[0],
            vitalValues,
            feedback: ele
          })

          optionsData.carbonDioxideAiMarkPoint.data.splice(optionsData.carbonDioxideAiMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: carbonDioxide?.value,
            alert: carbonDioxide?.alerts[0],
            vitalValues,
            feedback: ele
          })
        }
      })
    } else {
      submittedFeedbacks.some(ele => {
        if (ele.startTime === datetime && carbonDioxide?.value >= 0) {
          optionsData.carbonDioxideFeedbackPoint.data.push({
            xAxis,
            yAxis: carbonDioxide?.value,
            vitalValues,
            feedback: ele
          })

          if (optionsData.carbonDioxideData[0].length) {
            const normalPointIndex = optionsData.carbonDioxideData[0].findIndex(e => (new Date(e[0]).getTime() / 1000) === datetime)
            if (normalPointIndex > -1) {
              optionsData.carbonDioxideData[0][normalPointIndex].feedback = ele
            }
          }
        }
      })
    }

    // sulphurDioxide mark point
    if ((!alertId && sulphurDioxide?.alerts?.length && sulphurDioxide?.alerts?.some(a => !a?.isPseudoAlert)) || (alertId && sulphurDioxide?.alerts?.some(a => (a.id === alertId || a._id === alertId)))) {
      if (sulphurDioxide?.alerts[0].model_info.modelInfo === 'Default Settings') {
        optionsData.sulphurDioxideAlgoMarkPoint.data.push(
          {
            xAxis,
            yAxis: sulphurDioxide?.value,
            alert: sulphurDioxide?.alerts[0],
            vitalValues
          }
        )
      } else {
        optionsData.sulphurDioxideAiMarkPoint.data.push(
          {
            xAxis,
            yAxis: sulphurDioxide?.value,
            alert: sulphurDioxide?.alerts[0],
            vitalValues
          }
        )
      }

      submittedFeedbacks.some(ele => {
        if (ele.startTime === ele.endTime && ele.startTime === datetime) {
          optionsData.sulphurDioxideFeedbackPoint.data.push({
            xAxis,
            yAxis: sulphurDioxide?.value,
            alert: sulphurDioxide?.alerts[0],
            vitalValues
          })
          optionsData.sulphurDioxideAlgoMarkPoint.data.splice(optionsData.sulphurDioxideAlgoMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: sulphurDioxide?.value,
            alert: sulphurDioxide?.alerts[0],
            vitalValues,
            feedback: ele
          })

          optionsData.sulphurDioxideAiMarkPoint.data.splice(optionsData.sulphurDioxideAiMarkPoint.data.findIndex(e => e.xAxis === xAxis), 1, {
            xAxis,
            yAxis: sulphurDioxide?.value,
            alert: sulphurDioxide?.alerts[0],
            vitalValues,
            feedback: ele
          })
        }
      })
    } else {
      submittedFeedbacks.some(ele => {
        if (ele.startTime === datetime && sulphurDioxide?.value >= 0) {
          optionsData.sulphurDioxideFeedbackPoint.data.push({
            xAxis,
            yAxis: sulphurDioxide?.value,
            vitalValues,
            feedback: ele
          })

          if (optionsData.sulphurDioxideData[0].length) {
            const normalPointIndex = optionsData.sulphurDioxideData[0].findIndex(e => (new Date(e[0]).getTime() / 1000) === datetime)
            if (normalPointIndex > -1) {
              optionsData.sulphurDioxideData[0][normalPointIndex].feedback = ele
            }
          }
        }
      })
    }
    currentModel = model_info?.modelInfo
  }
  markArea.data = submittedFeedbacks.map(feedbackSession => {
    return [
      {
        xAxis: moment.formatDate(feedbackSession.startTime * 1000, 'DD MMM, YYYY, HH:mm:ss'),
        value: feedbackSession
      },
      {
        xAxis: moment.formatDate(feedbackSession.endTime * 1000, 'DD MMM, YYYY, HH:mm:ss'),
        value: feedbackSession
      }
    ]
  })
}

const addNewAlert = (option, data) => {
  optionsData[option].data.push(data)
}

const getBrushCoordinates = ({ unSubmittedFeedbacks, vitals }) => {
  return unSubmittedFeedbacks.map(({ startTime, endTime }) => {
    let startDateIndex = 1
    let endDateIndex = 1
    for (let i = 0; i < vitals.length; i++) {
      const { datetime } = vitals[i]
      if (startTime === datetime) {
        startDateIndex = i
      }
      if (endTime === datetime) {
        endDateIndex = i
      }
    }
    return {
      startDateIndex,
      endDateIndex
    }
  })
}

const prepareTemperatureOptions = ({ isFullView, minimize }) => {
  const { temperatureData, temperatureAlgoMarkPoint, temperatureAiMarkPoint, xAxisData, temperatureFeedbackPoint } = optionsData
  if (temperatureData?.length) {
    const temperatureValues = [].concat.apply([], temperatureData).map(s => s[1])
    let min = Math.min(...temperatureValues)
    min = isFinite(min) ? min : 0
    let max = Math.max(...temperatureValues)
    max = isFinite(max) ? max + 10 : 100

    const temperatureSeriesData = temperatureData.map(temperatureItem => ({
      name: 'Temperature',
      type: 'line',
      symbol: 'circle',
      smooth: false,
      symbolSize: 12,
      sampling: 'average',
      itemStyle: itemStyleNormal,
      lineStyle: {
        width: 1.5,
        // color: temperatureItem?.[0]?.[2]?.modelInfo?.isRuleEngine ? '#b35792' : '#5792B3'
        color: '#ffa000'
      },
      data: temperatureItem,
      markArea
    }))

    return {
      grid: {
        ...grid,
        ...minimize ? { height: '75%' } : {}
      },
      tooltip,
      animation: false,
      brush,
      toolbox,
      dataZoom: isFullView ? null : dataZoom,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        show: minimize || !isFullView,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          padding: [0, -100, 0, 0]
        },
        data: xAxisData
      },
      yAxis: {
        ...yAxis,
        min,
        max
      },
      series: [
        ...temperatureSeriesData,
        {
          name: 'Temperature Feedback',
          type: 'effectScatter',
          symbolSize: 12,
          data: temperatureFeedbackPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          itemStyle: scatterStyleFeedback,
          zlevel: 0
        },
        {
          name: 'Temperature Algo Markpoint',
          type: 'scatter',
          data: temperatureAlgoMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAlgoStyleAlert,
          zlevel: 1
        },
        {
          name: 'Temperature AI Markpoint',
          type: 'scatter',
          data: temperatureAiMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAiStyleAlert,
          zlevel: 1
        }
      ]
    }
  }
}

const prepareButaneOptions = ({ isFullView, minimize }) => {
  const { butaneData, butaneAlgoMarkPoint, butaneAiMarkPoint, xAxisData, butaneFeedbackPoint } = optionsData
  if (butaneData?.length) {
    const butaneValues = [].concat.apply([], butaneData).map(s => s[1])
    let min = Math.min(...butaneValues)
    min = isFinite(min) ? min : 0
    let max = Math.max(...butaneValues)
    max = isFinite(max) ? max : 100

    const butaneSeriesData = butaneData.map(butaneItem => ({
      name: 'Butane Saturation',
      type: 'line',
      smooth: false,
      symbol: 'circle',
      symbolSize: 12,
      sampling: 'average',
      itemStyle: itemStyleNormal,
      lineStyle: {
        width: 1.5,
        // color: butaneItem?.[0]?.[2]?.modelInfo?.isRuleEngine ? '#b35792' : '#5792B3'
        color: '#ffa000'
      },
      data: butaneItem,
      markArea
    }))

    return {
      grid: {
        ...grid,
        ...minimize ? { height: '75%' } : {}
      },
      tooltip,
      animation: false,
      brush,
      toolbox,
      dataZoom: isFullView ? null : dataZoom,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        show: minimize || !isFullView,
        axisLine: {
          show: false
        },
        axisLabel: {
          padding: [0, -100, 0, 0]
        },
        axisTick: {
          show: false
        },
        data: xAxisData
      },
      yAxis: {
        ...yAxis,
        min,
        max
      },
      series: [
        ...butaneSeriesData,
        {
          name: 'Butane Feedback',
          type: 'effectScatter',
          symbolSize: 12,
          data: butaneFeedbackPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          itemStyle: scatterStyleFeedback,
          zlevel: 0
        },
        {
          name: 'Butane Algo Markpoint',
          type: 'scatter',
          data: butaneAlgoMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAlgoStyleAlert,
          zlevel: 1
        },
        {
          name: 'Butane Ai Markpoint',
          type: 'scatter',
          data: butaneAiMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAiStyleAlert,
          zlevel: 1
        }
      ]
    }
  }
}

const prepareSulphurDioxideOptions = ({ minimize }) => {
  const { sulphurDioxideData, sulphurDioxideAlgoMarkPoint, sulphurDioxideAiMarkPoint, xAxisData, sulphurDioxideFeedbackPoint } = optionsData

  if (sulphurDioxideData?.length) {
    const sulphurDioxideValues = [].concat.apply([], sulphurDioxideData).map(s => s[1])
    let min = Math.min(...sulphurDioxideValues)
    min = isFinite(min) ? min : 0
    let max = Math.max(...sulphurDioxideValues)
    max = isFinite(max) ? max + 10 : 100

    const sulphurDioxideSeriesData = sulphurDioxideData.map(sulphurDioxideItem => ({
      name: 'sulphurDioxide',
      type: 'line',
      smooth: false,
      symbol: 'circle',
      symbolSize: 12,
      sampling: 'average',
      itemStyle: itemStyleNormal,
      lineStyle: {
        width: 1.5,
        // color: sulphurDioxideItem?.[0]?.[2]?.modelInfo?.isRuleEngine ? '#b35792' : '#5792B3'
        color: '#ffa000'
      },
      data: sulphurDioxideItem,
      markArea
    }))

    return {
      grid: {
        ...grid,
        ...minimize ? { height: '75%' } : {}
      },
      tooltip,
      animation: false,
      brush,
      toolbox,
      dataZoom,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          padding: [0, -100, 0, 0]
        },
        data: xAxisData
      },
      yAxis: {
        ...yAxis,
        min,
        max
      },
      series: [
        ...sulphurDioxideSeriesData,
        {
          name: 'sulphurDioxide Feedback',
          type: 'effectScatter',
          symbolSize: 12,
          data: sulphurDioxideFeedbackPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          itemStyle: scatterStyleFeedback,
          zlevel: 0
        },
        {
          name: 'sulphurDioxide Algo Markpoint',
          type: 'scatter',
          data: sulphurDioxideAlgoMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAlgoStyleAlert,
          zlevel: 1
        },
        {
          name: 'sulphurDioxide AI Markpoint',
          type: 'scatter',
          data: sulphurDioxideAiMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAiStyleAlert,
          zlevel: 1
        }
      ]
    }
  }
}
const prepareCarbonDioxideOptions = ({ isFullView, minimize }) => {
  const { carbonDioxideData, carbonDioxideAlgoMarkPoint, carbonDioxideAiMarkPoint, xAxisData, carbonDioxideFeedbackPoint } = optionsData
  if (carbonDioxideData?.length) {
    const carbonDioxideValues = [].concat.apply([], carbonDioxideData).map(s => s[1])
    let min = Math.min(...carbonDioxideValues)
    min = isFinite(min) ? min : 0
    let max = Math.max(...carbonDioxideValues)
    max = isFinite(max) ? max : 100

    const carbonDioxideSeriesData = carbonDioxideData.map(cdItem => ({
      name: 'CarbonDioxide',
      type: 'line',
      smooth: false,
      symbol: 'circle',
      symbolSize: 12,
      sampling: 'average',
      itemStyle: itemStyleNormal,
      lineStyle: {
        width: 1.5,
        // color: cdItem?.[0]?.[2]?.modelInfo?.isRuleEngine ? '#b35792' : '#5792B3'
        color: '#ffa000'
      },
      data: cdItem,
      markArea
    }))

    return {
      grid: {
        ...grid,
        ...minimize ? { height: '75%' } : {}
      },
      tooltip,
      animation: false,
      brush,
      toolbox,
      dataZoom: isFullView ? null : dataZoom,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        show: minimize || !isFullView,
        axisLine: {
          show: false
        },
        axisLabel: {
          padding: [0, -100, 0, 0]
        },
        axisTick: {
          show: false
        },
        data: xAxisData
      },
      yAxis: {
        ...yAxis,
        min,
        max
      },
      series: [
        ...carbonDioxideSeriesData,
        {
          name: 'CarbonDioxide Feedback',
          type: 'effectScatter',
          symbolSize: 12,
          data: carbonDioxideFeedbackPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          itemStyle: scatterStyleFeedback,
          zlevel: 0
        },
        {
          name: 'CarbonDioxide Algo Markpoint',
          type: 'scatter',
          data: carbonDioxideAlgoMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAlgoStyleAlert,
          zlevel: 1
        },
        {
          name: 'CarbonDioxide AI Markpoint',
          type: 'scatter',
          data: carbonDioxideAiMarkPoint.data.map(data => [data.xAxis, data.yAxis, data]),
          symbol: 'circle',
          symbolSize: 12,
          markArea,
          itemStyle: scatterAiStyleAlert,
          zlevel: 1
        }
      ]
    }
  }
}

export {
  optionsData,
  prepareData,
  prepareTemperatureOptions,
  prepareButaneOptions,
  prepareSulphurDioxideOptions,
  prepareCarbonDioxideOptions,
  addNewAlert,
  getBrushCoordinates
}
